<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'Input',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'maxlength', 'id', 'password', 'dense', 'color'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-checkbox
    class="py-0 my-0"
    v-model="model"
    :dense="dense"
    :id="id"
    :placeholder="placeholder"
    :rules="rules"
    outlined
    :label="label"
    :color="color"
  />
</template>
